module.exports = __webpack_public_path__ + "img/ys_chat.66ee6279.jpg";